import AboutUs from "../../components/AboutUs";
import useFetch from "../../hooks/useFetch";
import { API_URI } from "../../helpers/constants";
import { FullLoader } from "../../components/FullLoader/Loader";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAboutPage } from "../../redux/file";
import { Helmet } from "react-helmet";

export default function About() {
  const dispatch = useDispatch();
  const { data: bannerData, loading: bannerLoading } = useFetch(
    `${API_URI}/about-us-banners`
  );
  const { data, loading } = useFetch(`${API_URI}/about-us-pages`);
  const { data: topics } = useFetch(`${API_URI}/about-us-topics`);

  useEffect(() => {
    dispatch(setAboutPage(data));
  }, [data]);

  return (
    <>
      <Helmet>
        <title>{data?.[0]?.SEO?.metaTitle}</title>
        <meta name="description" content={data?.[0]?.SEO?.metaDescription} />
        <link rel="canonical" href={data?.[0]?.SEO?.canonicalURL} />
        <meta property="og:title" content={data?.[0]?.SEO?.metaTitle} />
        <meta name="og:description" content={data?.[0]?.SEO?.metaDescription} />
        <meta
          property="og:image"
          content={`${API_URI}${data?.[0]?.SEO?.metaImage?.url}`}
        />
      </Helmet>
      
      {loading && <FullLoader />}
      {bannerLoading && <FullLoader />}
      {data && bannerData && (
        <AboutUs bannerData={bannerData} topics={topics}></AboutUs>
      )}
    </>
  );
}
